module.exports = __webpack_public_path__ + "img/logo.fbe65de7.jpg";